import {CodeForm, Dialog, DialogAlignment, DialogTitle} from "@variocube/cube-ui";
import * as React from "react";
import {style} from "typestyle";
import {useLocalization} from "../i18n";

interface CodeDialogProps {
    open: boolean;
    onClose: () => void;
    onVerify: (code: string) => Promise<void>;
}

export function CodeDialog({open, onClose, onVerify}: CodeDialogProps) {
    const {t} = useLocalization();
    return (
        <Dialog open={open} align={DialogAlignment.Center} onBackdropClick={onClose}>
            <div className={style({width: "45em"})}>
                <DialogTitle>
                    {t("EnterCode")}
                </DialogTitle>
                {open && (
                    <CodeForm
                        onVerify={onVerify}
                        onCancel={onClose}
                        strings={t}
                    />
                )}
            </div>
        </Dialog>
    );
}

